var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Graph_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.224 1.28624C39.8228 0.748709 40.615 0.466951 41.4258 0.503093C58.5663 1.01621 72.8914 13.4593 75.4877 30.0899C75.5042 30.1892 75.5042 30.2904 75.4877 30.3897C75.5436 31.1766 75.2776 31.9529 74.7487 32.5469C74.2197 33.1409 73.4713 33.5037 72.669 33.555L43.8709 35.4541C42.9186 35.5386 41.9741 35.2252 41.2695 34.591C40.5648 33.9567 40.1654 33.0604 40.1693 32.1223L38.2336 3.83494V3.36848C38.2688 2.57291 38.6251 1.82376 39.224 1.28624ZM37.2487 42.851L62.1113 41.3184H62.3791C63.4509 41.3359 64.4718 41.7705 65.2169 42.5266C65.9621 43.2827 66.3706 44.2983 66.3524 45.3499C65.3688 59.6828 54.8606 71.6584 40.5604 74.7436C26.2602 77.8288 11.6007 71.2831 4.57918 58.6773C2.51457 55.0466 1.20988 51.0479 0.741702 46.9159C0.560117 45.6915 0.480614 44.4546 0.503982 43.2175C0.551309 27.9767 11.4023 14.8217 26.5853 11.5983C28.4233 11.2543 30.2661 12.172 31.068 13.8307C31.4641 14.428 31.5668 15.1593 31.6135 15.8746C31.8763 19.9024 32.1473 23.8967 32.4172 27.8756C32.6494 31.2979 32.8808 34.7089 33.1056 38.1198C33.094 38.9233 33.2203 39.723 33.4791 40.4854C34.0885 41.9855 35.6051 42.9372 37.2487 42.851Z",
    fill: "#F9F5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsicon);
export default __webpack_public_path__ + "static/media/insightsicon.7cbfcf9513dcd57993d5e1485f7b46d3.svg";
export { ForwardRef as ReactComponent };